import React, { useState ,useEffect}from 'react'
import {RTL} from './../Contact/Contact'
import './Login.css'
import {login,API_URL} from '../../constants'
import axios from 'axios'
import {useDispatch , useSelector} from 'react-redux'
import {Link, useHistory} from 'react-router-dom'
import image_logi from  '../../assets/businessman-handshaking-businesswoman-showing-respect-closeup-view-of-hands-shaking.jpg'
import {Button , CircularProgress} from '@material-ui/core'
import RoadMap from "../Footer/RoadMap";
import logo from '../../assets/logo.svg'
export default function Login() {
    const auth = useSelector(state => state.auth)
    const history = useHistory()

    useEffect(()=>{
        // if (auth !== null){
        //     history.push('/home')
        // }
    },[])
    return (
        <RTL>
         { auth !== null ? history.push('/home/dossiers') :

         <div className='login__wrapper'>
         <LoginForm/>
         </div>
         
        }
        </RTL>
    )
}

// headers
let config = {
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  }
}


function LoginForm() {

    //
    const history = useHistory()
    const dispatch = useDispatch()

    // 
    const {usernamee , passwrd,action } = login

    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [error, setError] = useState('')

    const [loading, setLoading] = useState(false)
    //loggin to the account
    const logIn = () => {
        console.log("button clicked");
        setLoading(true)
        axios.post(API_URL+'/users/login',{
            email: email,
            password : password,
        },config).then(res=>{
            console.log(res);
            if(res.status == 200){

                dispatch({
                    type:"LOGIN",
                    authUser : {
                        token : res.data.token,
                        userId : res.data.userId
                    }
                })
                setLoading(false)
                history.push('/home/dossiers')
            }else{

                setError('user ou password incorrecte!')
                setEmail('')
                setPassword('')
            }
        }).catch(err => {
            setError('error server')
             setEmail('')
                setPassword('')
        })
       
    }
    return (
        <div className='login'>
            <div color="red" >
            {error}

            </div>
            <div className='login__left'>
                <label>{usernamee.title}</label>
                <input 
                value={email} 
                onChange={e => setEmail(e.target.value)} 
                type='text' 
                placeholder={usernamee.placeholder} />
              <label>{passwrd.title}</label>

                <input 
                value={password} 
                onChange={e => setPassword(e.target.value)}  
                type='password' 
                placeholder={passwrd.placeholder} />
                <Button onClick={logIn} style={{color:'#1572b4'}} >
                    {
                        loading? <CircularProgress/> : action.login
                    }

                </Button>
            </div>
            <div className='login__right' >
                <img src={image_logi} />
                <div className="layer">

                </div>
            </div>
        </div>
    )
}
